@if (elmFound()) {
  <button type="button" matButton="filled" (click)="skipToMain()">
    {{ btnText }}
  </button>
}
